import { Injectable } from '@angular/core';
import { WorkflowApiService } from '@selfai-platform/pipeline-api';
import { Observable } from 'rxjs';
import { WorkflowSettingsPresetsBinding } from '../interface/workflow-settings-presets-binding.interface';

@Injectable()
export class WorkflowSettingsPresetsBindingDomainService {
  workflowSettingsPresetsBinding$!: Observable<WorkflowSettingsPresetsBinding[]>;

  constructor(private readonly workflowApiService: WorkflowApiService) {}

  updatePreset(data: WorkflowSettingsPresetsBinding): Observable<string> {
    return this.workflowApiService.bindPresetToWorkflow(data.presetId, data.id);
  }
}
